const MAX_FORUM_PHOTOS = 4;

/** Keep only uploaded image URLs. Caps the list so a post cannot attach a gallery dump. */
export function sanitizeForumImageUrls(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];
  const urls: string[] = [];
  for (const item of raw) {
    if (typeof item !== "string") continue;
    const url = item.trim();
    if (!url || url.length > 500) continue;
    const ok = url.startsWith("/uploads/") || /^https:\/\/.+/i.test(url);
    if (!ok) continue;
    urls.push(url);
    if (urls.length >= MAX_FORUM_PHOTOS) break;
  }
  return urls;
}

export { MAX_FORUM_PHOTOS };
